import dayjs from 'dayjs';
import { PROMOTION_2025_05_06_RAGTAG } from '~/app/_constants/promotion';

const formatPromotionPeriod = (startDate: string, endDate: string) =>
  `${dayjs(startDate).format('MM.DD')} ~ ${dayjs(endDate).format('MM.DD')}`;

export const getRagTagPromotionContent = (discountRate?: number) =>
  `${formatPromotionPeriod(
    PROMOTION_2025_05_06_RAGTAG.SCHEDULE.START_DATE,
    PROMOTION_2025_05_06_RAGTAG.SCHEDULE.END_DATE,
  )} 래그태그 상품 무제한 ${discountRate}% 할인`;
